<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add Operator</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Operator Name"
                        name="name"
                        type="textarea"
                        placeholder="Operator Name"
                        rules="required"
                        v-model="model.name">
            </base-input>
          </b-col>
          <b-col md="12">
            <base-input label="Operator Description"
                        name="name"
                        type="textarea"
                        placeholder="Operator Description"
                        v-model="model.description">
            </base-input>
          </b-col>
          
          <b-col md="12">
             <div class="dropzone-icon">
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="logoDropzone"
                  :options="dropzoneOptions"
                  ref="logo"
                />
             </div>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Operator</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'
  import vue2Dropzone from 'vue2-dropzone'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/operators/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "AddOperator",
    components: {
        HtmlEditor,
        //DropzoneFileUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions,
        vue2Dropzone
    },
    data() {
      return {
        model: {
          name: '',
          description: '',
          dropzone: [],
          isActive: true,
          isDeleted: false,
          isVisible: true,
        },
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          maxFiles: 1,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        if (this.model.name) {
          try {
              dispatch("operators/addOperator", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Operator Added'});
                  const { dispatch } = this.$store;
                  dispatch("operators/getAllOperators");
                  this.$router.push({path: '/operators'});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: operator add", error);
          }
        }
      },
      maxFilesExceeded(file) {
        this.$refs.logo.removeAllFiles()
        this.$refs.logo.addFile(file)
        this.model.dropzone = []
        this.model.dropzone.push(file)
      },
      fileAdded(file) {
        this.model.dropzone = []
        this.model.dropzone.push(file)
      }
    },
    resetForm() {
        this.model.id = '';
        this.model.description = '';
    },
    computed: {
    },
    mounted() {
     
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
